let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("krcPB")).then(() => parcelRequire('dugsO'));